import { api } from "./api";

export type MarketsUser = {
	id: string;
	email: string | null;
	name: string | null;
	role: string;
	permissions: string[];
	appAccess: string[];
	sitePermissions: Record<string, string[]>;
	avatarUrl: string | null;
	totpEnabled: boolean;
	org: {
		id: string;
		kind: "brand" | "affiliate";
		legalName: string;
		displayName: string;
		role: string;
	} | null;
};

export async function fetchMe(): Promise<MarketsUser | null> {
	try {
		return await api.get<MarketsUser>("/me");
	} catch {
		return null;
	}
}
